/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useState, useCallback, useEffect } from 'react';
import { BiDollarCircle } from 'react-icons/bi';
import { useToast } from '../../hooks/toast';
import LoaderModal from '../../components/LoaderModal';
import { ArrayFilters } from '../../interfaces/ticket';
import TarifasTable from './components/TarifasTable';
import { formatPrice } from '../../services/currency';
import { Row, Column, IconContainer } from '../../styles/components';
import CoreService from '../../services/core';
import { Container, Title } from './styles';

interface Tarifa {
  CodigoDaTarifa: number;
  Descricao: string;
  DataFimValidade: string;
  Valor: number;
  IdentifTarifa: string;
}
const Tarifas: React.FC = () => {
  const service = { CoreService: new CoreService() };
  const { addToast } = useToast();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(50);
  const [totalRows] = useState<number>(0);
  const [tarifas, setTarifas] = React.useState<Tarifa[]>([]);

  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{ page }, { quantity: perPage }],
  });
  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  useEffect(() => {
    async function getTarifas() {
      try {
        setLoading(true);
        const response = await service.CoreService.getTarifasPorLinha();
        setTarifas(response.data.ListaInformacoesDeTarifa);
        setLoading(false);
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro interno do servidor',
          description: 'Por favor tente novamente mais tarde',
        });
        setLoading(false);
        console.error(err);
      }
    }
    getTarifas();
  }, [filters]);

  return (
    <Container>
      <Row className="titleWrapper">
        <Column small="1" medium="1" large="1">
          <IconContainer align="center">
            <BiDollarCircle />
          </IconContainer>
        </Column>
        <Column small="10" medium="10" large="10" className="TitleContainer">
          <Title>Tarifas por linha</Title>
        </Column>
      </Row>
      <Row className="column">
        <Column small="12" medium="12" large="12">
          <TarifasTable
            data={tarifas}
            columns={[
              {
                name: 'Descrição',
                selector: 'Descricao',
              },
              {
                name: 'Código da linha',
                selector: 'IdentifTarifa',
              },
              {
                name: 'Valor',
                selector: 'Valor',
                cell: ({ Valor }: any) => (
                  <>
                    <div>{formatPrice(Valor)}</div>
                  </>
                ),
              },
            ]}
            loading={loading}
            totalRows={totalRows}
            perPage={perPage}
            onChangePage={handleChangePerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            emptyText="Nenhuma Tarifa cadastrada"
          />
        </Column>
      </Row>

      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
    </Container>
  );
};

export default Tarifas;
